export default __webpack_public_path__ + "staticlp1/media/banner-1-item-1.dbaecac9.png";